import React from "react";

import AdminPageGuard from "../components/AdminPageGuard";
import ShowWorkflow from "./showWorkflow/ShowWorkFlow";
import "../workflow/workflow.scss";

const index = () => {
  return (
    <AdminPageGuard>
      <ShowWorkflow />
    </AdminPageGuard>
  );
};

export default index;
